module.exports = "<svg fill=\"#000000\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./src/assets/svg/menu.vue.svg
// module id = +tYd
// module chunks = 1